import React, { useContext } from 'react';
import { LanguageContext } from '../context/LanguageContext';
import { translations } from '../locales/translations';
import './Home.css';

function Home() {
  const { language } = useContext(LanguageContext);
  const t = translations[language].home;

  const features = [
    { title: t.feature1_title, description: t.feature1_desc, icon: '📊' },
    { title: t.feature2_title, description: t.feature2_desc, icon: '📈' },
    { title: t.feature3_title, description: t.feature3_desc, icon: '💼' },
    { title: t.feature4_title, description: t.feature4_desc, icon: '☁️' },
    { title: t.feature5_title, description: t.feature5_desc, icon: '⏯️' },
    { title: t.feature6_title, description: t.feature6_desc, icon: '📉' }
  ];

  const steps = [
    { title: t.step1_title, description: t.step1_desc, icon: '1️⃣' },
    { title: t.step2_title, description: t.step2_desc, icon: '2️⃣' },
    { title: t.step3_title, description: t.step3_desc, icon: '3️⃣' }
  ];

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">{t.hero_title}</h1>
            <p className="hero-subtitle">{t.hero_subtitle}</p>
            <p className="hero-description">{t.hero_description}</p>
            <div className="hero-buttons">
              <a href="#features" className="btn btn-primary">{t.learn_more}</a>
              <a href="https://apps.apple.com/cn/app/%E6%9C%9F%E8%B4%A7%E6%A8%A1%E6%8B%9F%E5%99%A8/id6757973478" className="btn btn-secondary" target="_blank" rel="noopener noreferrer">
                🍎 {t.download_ios}
              </a>
            </div>
          </div>
          <div className="hero-visual">
            <div className="phone-mockup">
              <div className="phone-screen">
                <div className="app-preview">
                  <div className="chart-placeholder">
                    <div className="chart-line"></div>
                    <div className="chart-candles">
                      <div className="candle green"></div>
                      <div className="candle red"></div>
                      <div className="candle green"></div>
                      <div className="candle green"></div>
                      <div className="candle red"></div>
                    </div>
                  </div>
                  <div className="controls-placeholder">
                    <div className="control-btn green">Buy</div>
                    <div className="control-btn red">Sell</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="section features-section">
        <div className="container">
          <h2 className="section-title">{t.features_title}</h2>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon">{feature.icon}</div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="section how-section">
        <div className="container">
          <h2 className="section-title">{t.how_title}</h2>
          <div className="steps-container">
            {steps.map((step, index) => (
              <div key={index} className="step-card">
                <div className="step-icon">{step.icon}</div>
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">{t.cta_title}</h2>
            <p className="cta-subtitle">{t.cta_subtitle}</p>
            <a href="https://apps.apple.com/cn/app/%E6%9C%9F%E8%B4%A7%E6%A8%A1%E6%8B%9F%E5%99%A8/id6757973478" className="btn btn-primary btn-large" target="_blank" rel="noopener noreferrer">
              {t.download_now}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
